/** Matches Invitee / Yardi list row counts */
export const TRANSFER_PER_PAGE_OPTIONS = [15, 30, 50, 100] as const
